// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-section-tsx": () => import("../src/templates/section.tsx" /* webpackChunkName: "component---src-templates-section-tsx" */),
  "component---src-pages-404-tsx": () => import("../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

